"use client";

import { ShoppingBagIcon } from "lucide-react";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";
import { useCart } from "./cart-context";

interface CartButtonProps {
	itemCount: number | null;
}

export function CartButton({ itemCount }: CartButtonProps) {
	const { openCart } = useCart();
	const t = useTranslations("cart");
	const nav = useTranslations("nav");

	return (
		<button
			type="button"
			onClick={() => openCart("header")}
			data-testid="CartNavItem"
			className={cn(
				"relative inline-flex items-center justify-center transition-colors",
				"h-9 w-9 rounded-lg hover:bg-accent hover:text-accent-foreground",
				"lg:h-[38px] lg:w-[38px] lg:rounded-full lg:bg-foreground lg:text-background lg:hover:bg-primary lg:hover:text-background",
			)}
		>
			<ShoppingBagIcon className="h-5 w-5 lg:h-4 lg:w-4" aria-hidden="true" />
			{itemCount != null && itemCount > 0 && (
				<span
					key={itemCount}
					className={cn(
						"absolute flex items-center justify-center rounded-full text-[10px] font-bold",
						"motion-cart-badge",
						"-right-0.5 -top-0.5 h-4 w-4 bg-foreground text-background",
						"lg:-right-0.5 lg:-top-0.5 lg:h-[17px] lg:w-[17px] lg:border-2 lg:border-background lg:bg-background lg:text-foreground",
					)}
				>
					{itemCount > 9 ? "9+" : itemCount}
				</span>
			)}
			<span className="sr-only">
				{itemCount == null ? nav("cartAria") : t("cartButtonLabel", { count: itemCount })}
			</span>
		</button>
	);
}
